import { useModalState } from '@bechtel/gds';
import { ToolRoom } from '@bechtel/ht-types';
import { useNavigate } from 'react-router';
import { SelectToolRoomDialog } from '~/components/select-tool-room';

export const NewReservation = () => {
  const { close } = useModalState(true);
  const navigate = useNavigate();

  const onToolRoomSelect = (toolRoom: ToolRoom) => {
    //onToolRoomSelection(toolRoom);
    close();
    navigate(`/reservations/new/${toolRoom.id}`);
  };

  const onClose = () => {
    close();
    navigate('/reservations');
  };

  return <>{<SelectToolRoomDialog onCancel={onClose} onSelect={onToolRoomSelect}></SelectToolRoomDialog>}</>;
};
